/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ControlUncontainEndpointAction = {
    Unisolate: 'unisolate'
} as const;
export type ControlUncontainEndpointAction = typeof ControlUncontainEndpointAction[keyof typeof ControlUncontainEndpointAction];


export function ControlUncontainEndpointActionFromJSON(json: any): ControlUncontainEndpointAction {
    return ControlUncontainEndpointActionFromJSONTyped(json, false);
}

export function ControlUncontainEndpointActionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlUncontainEndpointAction {
    return json as ControlUncontainEndpointAction;
}

export function ControlUncontainEndpointActionToJSON(value?: ControlUncontainEndpointAction | null): any {
    return value as any;
}

